import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from '../slices/authSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithLogout = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    api.dispatch(logout());
    window.location.href = '/login';
  }

  return result;
};

export const analyticsApi = createApi({
  reducerPath: 'analyticsApi',
  baseQuery: baseQueryWithLogout,
  endpoints: (builder) => ({
    // Time-series overview: revenue / volume / success-rate per bucket + totals.
    getAnalyticsOverview: builder.query({
      query: ({ range, isTestnet }) =>
        `/analytics/overview?range=${range}&isTestnet=${isTestnet}`,
      transformResponse: (response) => response?.data || null,
    }),

    // Breakdowns: top tokens / chains / by status / by type.
    getAnalyticsBreakdown: builder.query({
      query: ({ range, isTestnet }) =>
        `/analytics/breakdown?range=${range}&isTestnet=${isTestnet}`,
      transformResponse: (response) => response?.data || null,
    }),
  }),
});

export const {
  useGetAnalyticsOverviewQuery,
  useGetAnalyticsBreakdownQuery,
} = analyticsApi;
